import {Cronofy, SUCCESS_REPONSE_CODE, handleOtherResponseCode,
  UNPROCESSABLE_ENTITY_RESPONSE_CODE, CustomToastrAction} from '@/imports-files/pages/interviews/cronofy';
import {useEffect, useState, TRANSLATION} from '@/imports-files/common/common';

export function cronofyCallback(cronofyData, token, router, setInitialData,setLoading){

	const notification = cronofyData.notification
	if(notification.type == 'slot_selected'){
    setLoading(true)
		confirmSlot(notification, token, router, setInitialData,setLoading)
  }
  
}



export async function reuqestMoreDaysData(router, token, setInitialData, setShowPreferedTime, timezone){  
  const data                =   {request_more_slots: true, token: token, tzid: timezone}
  const result              =   await new Cronofy().getMoreDaysSlots(data);
  const status_code         =   result.status || result.response.status;
  const customToastrAction  =   new CustomToastrAction(); 

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      await setInitialData(result.data.data)
      setShowPreferedTime(true)
      // customToastrAction.setNormalToastr(result.data.success, 'success');
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'error')
      break;
    default: 
      handleOtherResponseCode(status_code,router);
  }
}

export async function confirmSlot(notification, token, router, setInitialData, setLoading){
	const data                =   {notification: notification, token: token}	
	const result              =	  await new Cronofy().interviewBooked(data);
	const status_code         =   result.status || result.response.status;
  const customToastrAction  =   new CustomToastrAction(); 
  setLoading(false);
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      setInitialData(result.data.data)
      // customToastrAction.setNormalToastr(result.data.success, 'success');
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      break;
    default: 
      handleOtherResponseCode(status_code,router);
  }
  
}

export async function requestForMoreSlots(args){
  const data                =   {token: args.token, candidate_meeting_preference: {preferred_date_time: `${args.values.preferred_date} ${args.values.preferred_time}`, reason: args.values.reason}, tzid: args.tzid}
  const result              =	  await new Cronofy().requestForSlots(data, args.type);
	const status_code         =   result.status || result.response.status;
  const customToastrAction  =   new CustomToastrAction(); 

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      args.setBtnPopup(false)
      args.setInitialData(result.data.data)
      customToastrAction.setNormalToastr(result.data.success, 'success');
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      break;
    default: 
      handleOtherResponseCode(status_code, args.router);
  }
}

export async function cancelInterviewByCandidate(values, token, router, setBtnPopup, setInitialData) {
    const data                =   {token: token, cancel_detail: values}  
    const result              =   await new Cronofy().cancelInterview(data);
    const status_code         =   result.status || result.response.status;
    const customToastrAction  =   new CustomToastrAction(); 
    
    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
        setBtnPopup(false)
        setInitialData(result.data.data)
        customToastrAction.setNormalToastr(result.data.success, 'success');

        break;
      case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        customToastrAction.setNormalToastr(result.response.data.error, 'error');
        break;
      default: 
        handleOtherResponseCode(status_code, router);
    }
}

export async function requestToReschedule(router, token, setInitialData){
  const data                =   {token: token}
  const result              =   await new Cronofy().rescheduleRequest(data);
  const status_code         =   result.status || result.response.status;
  const customToastrAction  =   new CustomToastrAction(); 

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      await setInitialData(result.data.data)
      if (result.data.success) {
        customToastrAction.setNormalToastr(result.data.success, 'success');
      }
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'error')
      break;
    default: 
      handleOtherResponseCode(status_code,router);
  }
}

export async function  updateContactNo(args) {
  const result              =   await new Cronofy().updateContactNo(args);
  const status_code         =   result.status || result.response.status;
  const customToastrAction  =   new CustomToastrAction();
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      // customToastrAction.setNormalToastr(result.data.success, 'success');
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      // customToastrAction.setNormalToastr(result.response.data.error, 'error');
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      // customToastrAction.setNormalToastr(result.response.data.error, 'error');
      break;
    default:
      handleOtherResponseCode(status_code,router);
  }
}

export function isValidContactNo(contactNo, setContactError){
  const phoneRegex = /^\+?[\d\s]+$/;
  if(contactNo){
    if(phoneRegex.test(contactNo)){
      if(contactNo.length < 8){
        setContactError(TRANSLATION('errors:contact_short'))
        return false;
      }
      if(contactNo.length > 20){
        setContactError(TRANSLATION('errors:contact_long'))
        return false;
      }
      setContactError('')
      return true;
    }
    else{
      setContactError(TRANSLATION('errors:no_special_char'))
      return false
    }
  }
  else{
    setContactError(TRANSLATION('errors:required'))
  }
}
